module.exports = __webpack_public_path__ + "static/img/work.280af8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/work.png
// module id = +DH7
// module chunks = 21